export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14012.2d4d7565.jpg";